<style>
  .read-more-wrap {
    position: relative;
    padding-bottom: 2.5rem;
    display: grid;
    grid-template-columns: repeat(auto-fit, 240px);
    grid-auto-flow: row;
    gap: 1rem;
    width: 100%;
    justify-content: center;
    margin: 0 auto;
    max-width: 800px;
  }

  .img-wrap {
    overflow: hidden;
  }

  .article-wrap {
    padding: 1rem 0;
  }

  .read-more-title {
    text-align: center;
    font-weight: 700;
    font-size: 1.125rem;
    line-height: 1.75rem;
    padding-top: 3rem;
  }

  h3 {
    font-weight: 400;
    letter-spacing: 0em;
    text-align: left;
    font-size: 1rem;
    padding: 0.25rem 1rem 1rem 1rem;
  }

  h3:hover {
    opacity: 0.5;
  }

  img {
    transition-property: transform;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 300ms;
    transform: translate3d(0 0 0 0 0 1 1);
    width: 100%;
  }

  img:hover {
    transform: scale(1.1);
  }

  @media (min-width: 650px) {
    .read-more-title {
      font-size: 1.5rem;
      line-height: 2rem;
    }
  }
</style>

<script>
  export let projectName
  export let articleData
</script>

<h2 class="read-more-title">推薦文章</h2>

<div class="read-more-wrap">
  {#each articleData.slice(0, 6) as { article_title, article_img_url, article_url }}
    <div class="article-wrap">
      <div class="img-wrap">
        <a
          href={`${article_url}?utm_source=TNL-interactive&utm_medium=article-zone&utm_campaign=${projectName}`}
          target="_blank"
        >
          <img src={article_img_url} alt="" />
        </a>
      </div>
      <a
        href={`${article_url}?utm_source=TNL-interactive&utm_medium=article-zone&utm_campaign=${projectName}`}
        target="_blank"
      >
        <h3>{article_title}</h3>
      </a>
    </div>
  {/each}
</div>
